let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1HNuh")).then(() => parcelRequire('1OT7K'));